import { useState } from 'react';

import { Agent } from '@models/agent.model';

import {
  ReportAgentContext,
  ReportAgentContextProps,
} from './report-agent-context';

const ReportAgentContextProvider = ({ children }) => {
  const [uniqueAgents, setUniqueAgents] = useState<Agent[]>([]);
  const [testPlanIdVsAgents, setTestPlanIdVsAgents] = useState<
    Record<string, Agent[]>
  >({});

  return (
    <ReportAgentContext.Provider
      value={
        {
          uniqueAgents,
          setUniqueAgents,
          testPlanIdVsAgents,
          setTestPlanIdVsAgents,
        } as ReportAgentContextProps
      }>
      {children}
    </ReportAgentContext.Provider>
  );
};

export default ReportAgentContextProvider;
